export default "__VITE_ASSET__CoDAEXNw__"